import Intercom, { update, shutdown } from '@intercom/messenger-js-sdk';
import { useEffect, useRef } from 'react';

const INTERCOM_APP_ID = 'yobcu3v6';

interface IntercomUser {
  id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  created_at?: string;
  current_tenant?: {
    id: string;
    name: string;
    roles: string[];
  };
}

export function useIntercom(user: IntercomUser | null) {
  const bootedRef = useRef(false);

  useEffect(() => {
    if (!user) {
      if (bootedRef.current) {
        shutdown();
        bootedRef.current = false;
      }
      return;
    }

    try {
      Intercom({
        app_id: INTERCOM_APP_ID,
        user_id: user.id,
        name: [user.first_name, user.last_name].filter(Boolean).join(' '),
        email: user.email || '',
        created_at: user.created_at
          ? Math.floor(new Date(user.created_at).getTime() / 1000)
          : undefined,
      });
      bootedRef.current = true;

      if (user.current_tenant) {
        update({
          roles: JSON.stringify(user.current_tenant.roles || []),
          company: {
            name: user.current_tenant.name || '',
            id: user.current_tenant.id || '',
          },
        });
      }
    } catch (error) {
      console.error('Failed to initialize Intercom:', error);
    }

    return () => {
      if (bootedRef.current) {
        shutdown();
        bootedRef.current = false;
      }
    };
  }, [user?.id]);
}
